import { API_URL } from '../../api/constants'

export const LOGIN_URL = `${API_URL}/auth/url`
